var _g, _style;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "115px",
    height: "115px",
    viewBox: "0 0 133 133",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "check-group",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "filled-circle",
    fill: "#00ffe1",
    cx: 66.5,
    cy: 66.5,
    r: 54.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "white-circle",
    fill: "#00ffe1",
    cx: 66.5,
    cy: 66.5,
    r: 55.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "outline",
    stroke: "#000000",
    strokeWidth: 4,
    cx: 66.5,
    cy: 66.5,
    r: 54.5
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "check",
    stroke: "#000000",
    strokeWidth: 5.5,
    points: "41 70 56 85 92 49"
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n#check-group {\n    animation: 0.32s ease-in-out 1.03s check-group;\n    transform-origin: center;\n}\n\n#check-group #check {\n    animation: 0.34s cubic-bezier(0.65, 0, 1, 1) 0.8s forwards check;\n    stroke-dasharray: 0, 75px;\n    stroke-linecap: round;\n    stroke-linejoin: round;\n}\n\n#check-group #outline {\n    animation: 0.38s ease-in outline;\n    transform: rotate(0deg);\n    transform-origin: center;\n}\n\n#check-group #white-circle {\n    animation: 0.35s ease-in 0.35s forwards circle;\n    transform: none;\n    transform-origin: center;\n}\n\n@keyframes outline {\n  from {\n    stroke-dasharray: 0, 345.576px;\n  }\n  to {\n    stroke-dasharray: 345.576px, 345.576px;\n  }\n}\n@keyframes circle {\n  from {\n    transform: scale(1);\n  }\n  to {\n    transform: scale(0);\n  }\n}\n@keyframes check {\n  from {\n    stroke-dasharray: 0, 75px;\n  }\n  to {\n    stroke-dasharray: 75px, 75px;\n  }\n}\n@keyframes check-group {\n  from {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(1.09);\n  }\n  to {\n    transform: scale(1);\n  }\n}\n")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadLoader);
export default __webpack_public_path__ + "static/media/uploadLoader.e6af4dc8213af6d668aac8484c642a33.svg";
export { ForwardRef as ReactComponent };